export const BASE_URL = process.env.REACT_APP_BASE_URL
export const APP_NAME = '@dls'
